export default __webpack_public_path__ + "static/media/Gilroy-ExtraBold.f0feeaf3.otf";